/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const SvgComponent: FC<IProps> = ({ width = 32, height = 32, fill = "none" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 30 30" fill={fill}>
    <path d="M4.19995 13.7999L25.8 7.79993V22.1999L4.19995 17.3999V13.7999Z" stroke="#262626" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.52 20.76C14.3939 21.217 14.1791 21.6447 13.8877 22.0186C13.5963 22.3926 13.2342 22.7055 12.8219 22.9395C12.4096 23.1735 11.9553 23.324 11.4848 23.3824C11.0143 23.4409 10.537 23.406 10.08 23.28C9.62298 23.1539 9.19528 22.9391 8.82132 22.6477C8.44735 22.3563 8.13443 21.9942 7.90043 21.5819C7.66642 21.1696 7.51592 20.7152 7.4575 20.2448C7.39909 19.7743 7.43391 19.297 7.55998 18.84" stroke="#262626" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
